import React from "react";

const CustomCheck = (props) => {
    const { control, onControlChange, customCheckStyle, backgroundColorCheckLabel } = props;
    const htmlFor = (control.Descripcion + control.PropiedadId);
    const estaMarcado = (control.Valor == 1);
    const esObligatorio = control.Obligatorio == true ? ' *' : '';

    /*para controles con valor null o undefined*/
    if (!control.Valor) {
        control.Valor = 0;
    }

    return (
        <div className={"checkbox-container" + customCheckStyle}>
            <input type="checkbox" checked={estaMarcado}
                value={control.Valor} id={htmlFor}
                onClick={(event) => {
                    event.target.value = (event.target.checked == true) ? 1 : 0;
                    onControlChange(event);
                }} />
            {/* Este label se superpone por encima del checkbox generando un checkbox con el estilo de Atlas */}
            <label className={"checkbox-nuevaInstancia" + backgroundColorCheckLabel} htmlFor={htmlFor}></label>
            {/* Se modifica de label a span para que no tome los estilos definidos para los tipos label */}
            <span className={"span-nuevaInstancia"}>{control.Descripcion} {esObligatorio}</span>
        </div>
    );
}

export default CustomCheck;